// @module CV.TariffCalculation.TariffModule
define('CV.TariffCalculation.TariffModule.View'
,	[
	'cv_tariffcalculation_tariffmodule.tpl'
	
	,	'CV.TariffCalculation.TariffModule.SS2Model'
	
	,	'Backbone'
    ]
, function (
	cv_tariffcalculation_tariffmodule_tpl
	
	,	TariffModuleSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class CV.TariffCalculation.TariffModule.View @extends Backbone.View
	return Backbone.View.extend({

		template: cv_tariffcalculation_tariffmodule_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new TariffModuleModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return CV.TariffCalculation.TariffModule.View.Context
	,	getContext: function getContext()
		{
			//@class CV.TariffCalculation.TariffModule.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
